define(function(require) {
    const _ = require('underscore');
    const ViewCell = require('./ViewCell');
    const ActionsView = require('app/Actions.view');

    /**
     * The row action cell
     * @param {Object} options
     * @returns column definition
     */
    const ActionCell = function(options) {
        return ViewCell(
            _.extend(
                {
                    ViewClass: ActionsView,
                    className: 'dt-body-left text-left',
                    width: '80px',
                    title: 'Actions',
                    prefix: 'actions',
                    type: 'html',
                    sortable: false,
                    viewOptionsFn: (data, type, row, meta, model) => {
                        return {
                            model: model,
                            data: options.actions
                        };
                    }
                },
                options
            )
        );
    };
    return ActionCell;
});
